import { useRolesQuery } from "../../utilities/queries/useRolesQuery";
import { Table } from 'reactstrap';
import { SquareCheckbox } from "../Inputs/SquareCheckbox/SquareCheckbox";
import { OrganizationalRoleType } from "../../constants/OrganizationalRoleType";
import Spinner from "../UISpinner/UISpinner";

export default function RenderRoles({ handleRoleSelect, selectedRole, roleSearchTerm, disableRoleSelection, exclude = [], includeOnly = [] }) {

    const { data: rolesData, isLoading, error } = useRolesQuery();
    let filteredRoles = [];
    if (!error) {
        filteredRoles = rolesData && rolesData.length > 0
            ? rolesData.filter(role => {
                const matchesSearch = role.roleName.toLowerCase().includes(roleSearchTerm.toLowerCase());
                const notExcluded = !exclude.includes(role.organizationalRoleType);
                const isIncluded = includeOnly.length === 0 || includeOnly.includes(role.organizationalRoleType);
                return matchesSearch && notExcluded && isIncluded;
            })
            : [];
    }
    return (
        <>
            {isLoading && <Spinner text="Loading roles..." />}
            <Table className="align-items-center table-flush table modal-table-sm" striped borderless>
                <tbody>
                    {filteredRoles?.length > 0 && filteredRoles.map((role) => {
                        const label = role.organizationalRoleType !== OrganizationalRoleType.Custom ? `${role.roleName} (default)` : role.roleName;
                        return (
                            <tr key={role.organizationalRoleId}>
                                <td className="pb-2 pt-2">
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ height: '100%', marginLeft: '-0.8rem' }}
                                    >
                                        <SquareCheckbox
                                            value={selectedRole === role.organizationalRoleType}
                                            label={label}
                                            id={`assign-role-${role.organizationalRoleId}`}
                                            valueChangeHandler={() => handleRoleSelect(role.organizationalRoleType)}
                                            disabled={disableRoleSelection}
                                        />
                                    </div>
                                </td>
                            </tr>

                        );
                    })}
                </tbody>
            </Table>
            
        </>
    )
}